module.exports = __webpack_public_path__ + "static/Pocket-Guide-77fece656191ca149981248f73f37358.png";